import React from 'react'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
// import Add250Tokens from '../Add250Tokens'
import Explain250 from '../SubscriptionExplainer/Explain250'
import Explain500 from '../SubscriptionExplainer/Explain500'

function BuySubscription({
    setOpenModal,
    openModal,
    auth
}) {
    return (
    <Transition.Root show={openModal} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        // initialFocus={completeButtonRef}
        open={openModal}
        onClose={setOpenModal}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div>
                <div className="mt-1 text-left">
                  <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                    Subscribe
                  </Dialog.Title>
                  <div
                  className="my-4 flex"
                  >
                      <div className="mr-3">
                      <Explain250 
                      auth={auth}
                      />
                      </div>
                      <div>
                        <Explain500 
                        auth={auth}
                        />
                      </div>
                  </div>
                  <div
                  className="flex"
                  >
                    {/* <button
                    onClick={() => deleteVprop()}
                    className="p-2 rounded-lg bg-red-600 text-white hover:bg-red-800 focus:outline-none"
                    >
                        Delete
                    </button> */}
                    {/* <button
                    className="ml-3 p-2 rounded-lg bg-gray-600 text-white hover:bg-gray-800 focus:outline-none"
                    onClick={() => setOpenModal(false)}
                    >
                        Cancel
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
    )
}

export default BuySubscription
